// @source app/models/page_customizables/network.rb
export const networkPagesIdentifiersFeaturesMap = {
  business_opportunities: 'business_opportunities',
  companies: 'companies',
  donations: 'donations',
  events: 'events',
  feed: 'live_feed',
  forum: 'forum',
  homepage: 'homepage',
  journeys: 'journeys',
  media_center: 'media_center',
  memberships: 'memberships',
  my_profile: 'my_profile',
  news: 'news',
  portfolios: 'portfolio',
  public_page: 'public_page',
  topics: 'topics',
  users: 'people_directory',
  ventures: 'ventures',
} as const;

// @source: app/models/page_customizables/topic.rb
export const topicPagesIdentifiersFeaturesMap = {
  home: 'home',
  feed: 'feed',
  members: 'members',
  memberships: 'memberships',
  events: 'events',
  news: 'news',
  media_center: 'media_center',
  ventures: 'ventures',
  forum: 'forum',
  jobs: 'jobs',
} as const;

export const networkToTopicIdentifiersMap = {
  ...Object.fromEntries(
    Object.keys(networkPagesIdentifiersFeaturesMap).map((id) => [id, id]),
  ),
  homepage: 'home',
  users: 'members',
  business_opportunities: 'jobs',
};

export type PageIdentifier = keyof typeof networkPagesIdentifiersFeaturesMap;

export type PagesMap = {
  [K in keyof typeof networkPagesIdentifiersFeaturesMap as Uppercase<K>]: K;
};

export const PAGES: PagesMap = Object.keys(
  networkPagesIdentifiersFeaturesMap,
).reduce((acc, identifier) => {
  acc[identifier.toUpperCase()] = identifier;
  return acc;
}, {} as PagesMap);

export const DEFAULT_PAGE_NAMES = {
  [PAGES.BUSINESS_OPPORTUNITIES]: __('Jobs'),
  [PAGES.COMPANIES]: __('Companies'),
  [PAGES.DONATIONS]: __('Donations'),
  [PAGES.EVENTS]: __('Events'),
  [PAGES.FEED]: __('Live feed'),
  [PAGES.FORUM]: __('Forum'),
  [PAGES.HOMEPAGE]: __('Home'),
  [PAGES.JOURNEYS]: __('Journeys'),
  [PAGES.MEDIA_CENTER]: __('Media Center'),
  [PAGES.MEMBERSHIPS]: s__('Memberships|Memberships'),
  [PAGES.NEWS]: __('News'),
  [PAGES.PORTFOLIOS]: __('Portfolio'),
  [PAGES.TOPICS]: __('groups'),
  [PAGES.USERS]: s__('Feature|People Directory'),
  [PAGES.VENTURES]: __('Projects'),
};
